import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    days: 'days',
    months: 'months',
    validityPeriod: 'Validity period',
    weeks: 'weeks',
  },
  fr: {
    days: 'jours',
    months: 'mois',
    validityPeriod: 'Durée de validité limitée',
    weeks: 'semaines',
  },
} as const);

export default locales;
